import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import spinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import { BToast } from 'bootstrap-vue'
import ItensCarrinho from '@/views/carrinho/ItensCarrinho.vue'
import CodigoPromocional from '@/views/carrinho/CodigoPromocional.vue'
import Resumo from '@/views/carrinho/Resumo.vue'
import Progresso from '@/views/carrinho/Progresso.vue'
import Total from '@/views/carrinho/Total.vue'
import DadosEscritorio from '@/views/carrinho/DadosEscritorio.vue'
import Pagamento from '@/views/carrinho/Pagamento.vue'
import { mapState, mapGetters, mapActions } from 'vuex'
import util from '@/util'
import mensagens from '@/util/mensagens'
import constants from '@/util/constants'

export default {
  name: 'carrinho',
  components: {
    cabecalho,
    menuLateral,
    spinnerProcessando,
    'b-toast': BToast,
    ItensCarrinho,
    CodigoPromocional,
    Resumo,
    Progresso,
    DadosEscritorio,
    Pagamento,
    Total
  },

  computed: {
    ...mapState('auth', ['regrasLogin']),
    ...mapState('carrinho', ['itens', 'cupomData']),
    ...mapState('formaspagamento', ['estaCadastrandoCartao', 'formularioFormaDePagamentoCliente']),
    ...mapGetters('carrinho', ['obterValorTotalCarrinho', 'itensCarrinho']),
    temPagamentoPendente () {
      if (util.valorVazio(this.regrasLogin)) {
        return false
      }
      const pendenciasDeLogin = JSON.parse(this.regrasLogin)
      if (util.valorVazio(pendenciasDeLogin.pagamentoPendente)) {
        return false
      }
      return pendenciasDeLogin.pagamentoPendente
    },
    ehCarrinho () {
      return this.progresso === 1
    },
    ehConfirmacaoDados () {
      return this.progresso === 2
    },
    ehPagamento () {
      return this.progresso === 3
    },

    ehProdutoMirt () {
      if (!util.valorVazio(this.itensCarrinho)) {
        return this.itensCarrinho.some(item => item.produto.id === constants.idProdutoMirt) && this.ehCarrinho
      }
    },
    obterValorTotal () {
      return Number(this.detalhesFatura.valor_total)
    }
  },

  data: () => {
    return {
      erroPagamento: false,
      podePagar: true,
      mensagem: null,
      loading: false,
      progresso: 1,
      dadosRetornoContrato: null,
      listaConfiguracaoFatura: null,
      pagamentoSelecionado: null,
      cupom_selecionado: {},
      itensProporcional: [],
      dadosFormulario: {
        fatura_id: null,
        forma_pagamento: null,
        escritorio: {
          cpf_cnpj: '',
          numero_telefone: '',
          email: '',
          nome: '',
          salvarDadosDoEscritorio: true,
          cartao: {
            id: null
          },
          endereco: {
            cep: null,
            endereco: null,
            complemento: null,
            numero: null,
            bairro: null,
            cidade: null,
            uf: null,
            ibge: null,
            pais: 'Brasil'
          }
        }
      },
      itensPedidos: [],
      detalhesFatura: {},
      listaDeErros: {},
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      retorno: {
        sucesso: false,
        mensagem: '',
        listaDeErros: [],
        listaDados: {}
      }
    }
  },

  async mounted () {
    this.ActionDefinirEstaCadastrandoCartao(false)
    if (this.itens.length === 0) {
      this.ActionLimparCupomDataDoCarrinho()
    }

    const { idFatura, progresso } = this.$route.params
    if (!util.valorEhNulo(progresso)) {
      this.atualizarProgresso(Number(progresso))
    }

    if (!util.valorEhNulo(idFatura)) {
      await this.obterConfiguracaoPagamento(idFatura)
      await this.obterDadosDaFatura(idFatura)
    }

    // Aqui define onde esse componente esta sendo feito o loading
    this.ActionDefinirFormaPagamentoCliente({
      filho: 'carrinho'
    })
  },

  methods: {
    ...mapActions('formaspagamento', ['ActionDefinirEstaCadastrandoCartao', 'ActionDefinirFormaPagamentoCliente']),
    ...mapActions('carrinho', [
      'ActionDefinirDadosCarrinho', 'ActionLimparDadosCarrinho', 'ActionLimparCupomDataDoCarrinho'
    ]),
    ...mapActions('auth', ['ActionSetDadosAlertaDesbloqueioEscritorio']),
    voltarParaMercado () {
      this.$router.push({ name: 'mercado' })
    },
    async avancar () {
      if (this.ehConfirmacaoDados) {
        this.tratarAvancarConfirmacaoDados()
      }
    },
    atualizarPrecos () {
      this.$refs.totalComponente.atualizarPrecos()
    },
    async tratarAvancarCarrinho () {
      const podeAvancarParaConfirmacaoDados = this.$refs.itensCarrinho.podeAvancar
      if (!podeAvancarParaConfirmacaoDados) {
        util.criarAlertaToastDeErro(this, 'Aviso', 'Precisa de pelo menos um item para poder avançar')
        return
      }
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)

      await this.efetuarAceiteContrato()
      if (!util.valorVazio(this.dadosRetornoContrato)) {
        this.$router.push({ name: 'carrinho', params: { idFatura: this.dadosRetornoContrato.fatura, progresso: 2 } })
        this.$refs.progresso.proximo()
        this.ActionLimparDadosCarrinho()
      }
      this.definirFlagCarregandoDados(false, '')
    },
    async tratarAvancarCarrinhoMirt () {
      try {
        const podeAvancarParaConfirmacaoDados = this.$refs.itensCarrinho.podeAvancar
        if (!podeAvancarParaConfirmacaoDados) {
          util.criarAlertaToastDeErro(this, 'Aviso', 'Precisa de pelo menos um item para poder avançar')
          return
        }

        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
        await this.efetuarTrocaDePlano()

        if (!this.retorno.sucesso) {
          this.definirFlagCarregandoDados(false, '')
          return
        }

        if (!util.valorVazio(this.dadosRetornoContrato.fatura)) {
          this.$router.push({ name: 'carrinho', params: { idFatura: this.dadosRetornoContrato.fatura, progresso: 2 } })
          this.$refs.progresso.proximo()
          this.ActionLimparDadosCarrinho()
        }

        this.definirFlagCarregandoDados(false, '')
      } catch (e) {
        console.log(e)
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaComunicacaoServidor)
      }
    },

    async efetuarTrocaDePlano () {
      try {
        const item = await this.itensCarrinho.find(item => item.produto.id === constants.idProdutoMirt)
        const dadosProduto = util.mapearObjetos(item.produto, {})

        const parametrosRequisicao = {
          'plano_id': dadosProduto.plano.id,
          'quantidade': 1
        }
        const resposta = await this.axios.put('/manager/conta/contrato/produto/trocar-plano', parametrosRequisicao)
        this.retorno.sucesso = resposta.data.retorno.sucesso
        this.retorno.mensagem = resposta.data.retorno.mensagem
        this.retorno.listaDeErros = resposta.data.retorno.listaDeErros
        this.retorno.listaDados = resposta.data.retorno.listaDados
      } catch (e) {
        console.log(e)
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaComunicacaoServidor)
      }
      this.tratarAposSalvarRegistro()
    },
    async efetuarAceiteContrato () {
      try {
        const produtos = this.itensCarrinho
        const resposta = await this.efetuarContratacao(produtos)
        this.retorno.sucesso = resposta.data.retorno.sucesso
        this.retorno.mensagem = resposta.data.retorno.mensagem
        this.retorno.listaDeErros = resposta.data.retorno.listaDeErros
        this.retorno.listaDados = resposta.data.retorno.listaDados
      } catch (e) {
        console.log(e)
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaComunicacaoServidor)
      }
      this.tratarAposSalvarRegistro()
    },

    async efetuarContratacao (produtos) {
      const planos = produtos.map(item => ({
        plano_id: item.produto.plano.id,
        quantidade: item.produto.quantidade
      }))

      let cupom = null

      if (this.cupomData.length > 0) {
        const cupomData = JSON.parse(this.cupomData)

        if (cupomData.codigo !== undefined) {
          cupom = cupomData.codigo
        }
      }

      const parametrosRequisicao = {
        'planos': planos,
        'cupom': cupom
      }
      const resposta = await this.axios.post('/manager/conta/produtos/plano/contratar', parametrosRequisicao)
      return resposta
    },

    tratarAposSalvarRegistro () {
      if (this.retorno.sucesso) {
        this.ActionLimparDadosCarrinho()
        this.ActionLimparCupomDataDoCarrinho()
        util.criarAlertaToastDeSucesso(this, 'Aviso', this.retorno.mensagem)
        const dadosRetornoContrato = this.retorno.listaDados

        if (dadosRetornoContrato.ir_fatura) {
          this.$router.push({ name: 'faturaDetalhes', params: { id: dadosRetornoContrato.fatura } })
          return
        }

        this.dadosContratoConfirmado(dadosRetornoContrato)
      } else {
        util.criarAlertaToastDeErro(this, 'Aviso', this.retorno.mensagem)
      }
    },

    async dadosContratoConfirmado (dados) {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      this.dadosRetornoContrato = dados

      // Caso nao retorne a fatura envia direto para os contratos
      if (this.dadosRetornoContrato.fatura) {
        await this.obterConfiguracaoPagamento(this.dadosRetornoContrato.fatura)
        await this.obterDadosDaFatura(this.dadosRetornoContrato.fatura)
        this.itensProporcional = this.dadosRetornoContrato.proporcional
      } else {
        this.$router.push('/contratos').then(() => util.criarAlertaToastDeSucesso(this, 'Aviso', 'Produtos contratado com sucesso.'))
      }
      this.definirFlagCarregandoDados(false, '')
    },

    tratarAvancarConfirmacaoDados () {
      const podeAvancarParaPagamento = this.$refs.dadosEscritorio.podeAvancar
      if (!podeAvancarParaPagamento) {
        util.criarAlertaToastDeErro(this, 'Aviso', 'Confira os dados do escritório')
        return
      }
      this.$refs.progresso.proximo()
    },

    async contratar () {
      if (this.ehCarrinho) {
        await this.tratarAvancarCarrinho()
      }
    },

    async trocarDePlano () {
      if (this.ehProdutoMirt) {
        await this.tratarAvancarCarrinhoMirt()
      }
    },

    async efetuarPagamento () {
      if (this.estaCadastrandoCartao) {
        util.criarAlertaToastDeErro(this, 'Aviso', 'Você precisa finalizar o cadastro do cartão para efetuar o pagamento.')
        return
      }

      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      this.$refs.efetuarPagamento.disabled = true
      this.loading = true
      this.$refs.pagamento.isLoadingCartao = true
      this.listaDeErros = {}
      this.erroPagamento = false
      this.mensagem = ''
      try {
        this.$refs.pagamento.isLoading = true
        this.dadosFormulario.forma_pagamento = this.formularioFormaDePagamentoCliente.forma_pagamento_idselecionado
        const dadosFormulario = this.tratarDadosAntesEfetuarPagamento(this.dadosFormulario)
        const resposta = await this.axios.post(`/manager/conta/pagamento`, dadosFormulario)
        this.tratarAposEfetuarPagamento(resposta.data.retorno)
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.loading = false
      this.$refs.pagamento.isLoadingCartao = false
      this.$refs.pagamento.isLoading = false
      this.$refs.efetuarPagamento.disabled = false
      this.definirFlagCarregandoDados(false, '')
    },
    voltar () {
      if (this.erroPagamento) {
        this.$refs.modal.hide()
      }
    },

    tratarDadosAntesEfetuarPagamento (dadosFormulario) {
      const { escritorio } = dadosFormulario
      const { endereco } = escritorio

      return {
        ...dadosFormulario,
        escritorio: {
          ...escritorio,
          endereco: {
            ...endereco,
            cep: endereco.cep.replace(/\D/g, ''),
            uf: endereco.uf?.code
          }
        }
      }
    },
    tratarAposEfetuarPagamento ({ sucesso, listaDeErros, mensagem, listaDados }) {
      if (sucesso) {
        const desbloquearEscritorio = !!listaDados['notificar_desbloqueio']
        const dadosAlertaDesbloqueio = { desbloquearEscritorio, idFatura: this.dadosFormulario.fatura_id }
        this.ActionSetDadosAlertaDesbloqueioEscritorio(JSON.stringify(dadosAlertaDesbloqueio))
        this.$router.push({ name: 'faturaDetalhes', params: { id: this.dadosFormulario.fatura_id } })
        return
      }

      this.$refs.modal.show()
      this.erroPagamento = true
      this.listaDeErros = listaDeErros
      // this.$refs.pagamento.listaDeErros = this.listaDeErros
      this.$refs.dadosEscritorio.listaDeErros = this.listaDeErros
      this.mensagem = mensagem
      this.obterProgressoComErro()
    },

    obterProgressoComErro () {
      const erros = Object.keys(this.listaDeErros)
      const camposPagamento = Object.keys(this.dadosFormulario.escritorio.cartao)
      const camposEndereco = Object.keys(this.dadosFormulario.escritorio.endereco)
      const camposContato = ['numero_telefone', 'cpf_cnpj', 'email', 'nome']

      const temErrosPagamento = this.verificaErro(erros, camposPagamento)
      const temErrosEndereco = this.verificaErro(erros, camposEndereco)
      const temErrosContato = this.verificaErro(erros, camposContato)
      this.$refs.progresso.flags.dadosEscritorio = temErrosEndereco || temErrosContato
      this.$refs.progresso.flags.pagamento = temErrosPagamento
    },

    verificaErro (erros, campos) {
      return erros.some(chaveErro => {
        const partes = chaveErro.split('.')
        const campoErro = partes[partes.length - 1]
        return campos.includes(campoErro)
      })
    },

    atualizarProgresso (progresso) {
      this.progresso = progresso
    },

    atualizarResumo (itensPedido) {
      this.dadosResumo = itensPedido
    },

    async obterConfiguracaoPagamento (idFatura) {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)

      try {
        const resposta = await this.axios.get(`/manager/conta/faturas/${idFatura}/configuracao/pagamento`)
        if (resposta.data.retorno.dados.cobranca !== undefined) {
          this.listaConfiguracaoFatura = resposta.data.retorno.dados
          if (this.listaConfiguracaoFatura.pagamento.length > 0) {
            this.ActionDefinirFormaPagamentoCliente({
              forma_pagamento_selecionado_padrao: this.listaConfiguracaoFatura.formas_pagamento.filter((r) => r.id === this.listaConfiguracaoFatura.pagamento)[0].nome,
              forma_pagamento_idselecionado: this.listaConfiguracaoFatura.pagamento,
              pagamento_automatico: this.listaConfiguracaoFatura.pagamento_automatico
            })
          }
          this.cupom_selecionado = resposta.data.retorno.dados.cupom
          this.atualizarDados()
        } else {
          this.dadosVazio = true
        }
      } catch (e) {
        console.log(e)
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },

    atualizarDados () {
      this.dadosFormulario.fatura_id = this.listaConfiguracaoFatura.cobranca.id
      this.dadosFormulario.escritorio.endereco.cep = this.listaConfiguracaoFatura.endereco.cep
      this.dadosFormulario.escritorio.endereco.bairro = this.listaConfiguracaoFatura.endereco.bairro
      this.dadosFormulario.escritorio.endereco.cidade = this.listaConfiguracaoFatura.endereco.cidade
      this.dadosFormulario.escritorio.endereco.endereco = this.listaConfiguracaoFatura.endereco.endereco
      this.dadosFormulario.escritorio.endereco.uf = { code: this.listaConfiguracaoFatura.endereco.estado, label: this.listaConfiguracaoFatura.endereco.estado }
      this.dadosFormulario.escritorio.endereco.ibge = this.listaConfiguracaoFatura.endereco.ibge
      this.dadosFormulario.escritorio.endereco.numero = this.listaConfiguracaoFatura.endereco.numero
      this.dadosFormulario.escritorio.endereco.complemento = this.listaConfiguracaoFatura.endereco.complemento

      this.dadosFormulario.escritorio.numero_telefone = this.listaConfiguracaoFatura.escritorio.celular || this.listaConfiguracaoFatura.escritorio.telefone
      this.dadosFormulario.escritorio.cpf_cnpj = this.listaConfiguracaoFatura.escritorio.cpf_cnpj
      this.dadosFormulario.escritorio.email = this.listaConfiguracaoFatura.escritorio.email
      this.dadosFormulario.escritorio.nome = this.listaConfiguracaoFatura.escritorio.nome
      this.$emit('lista-configuracao-fatura', this.listaConfiguracaoFatura)
    },

    async obterDadosDaFatura (idFatura) {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        const resposta = await this.axios.get(`/manager/conta/faturas/${idFatura}`)
        this.detalhesFatura = resposta.data.retorno.dados.detalhes_fatura
        this.itensPedidos = resposta.data.retorno.dados.itens
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },
    atualizarId (id) {
      this.dadosFormulario.escritorio.cartao.id = id
    },
    formatarValorMonetario (valor) {
      if (util.valorEhNulo(valor)) return 'R$ 0'
      return util.formatarValorMonetarioComCifrao(valor)
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    resetarListaDeErros () {
      this.retorno.sucesso = false
      this.retorno.mensagem = ''
      this.retorno.listaDeErros = []
    }
  }
}
